import { CButton, CButtonGroup, CTooltip } from "@coreui/react";

import { useEffect, useState } from "react";
import PermissionRequiredComponent from "../permissions/PermissionRequiredComponent";
import {
  INVOICES_DESTROY,
  INVOICES_RETRIEVE,
  INVOICES_UPDATE,
} from "../../auth/permissions";
import { ReceivedInvoice } from "../../models/received-invoice";

interface InvoiceCrudAtionsProps {
  invoice: ReceivedInvoice;
  onReadClick: (_: ReceivedInvoice) => void;
  onUpdateClick: (_: ReceivedInvoice) => void;
  onDeleteClick: (_: ReceivedInvoice) => void;
}

const InvoiceCrudActions: React.FC<InvoiceCrudAtionsProps> = ({
  invoice,
  onReadClick,
  onUpdateClick,
  onDeleteClick,
}) => {
  const [currentInvoice, setCurrentInvoice] = useState(invoice);

  useEffect(() => {
    setCurrentInvoice(invoice);
  }, [invoice]);

  const editButton = (
    <PermissionRequiredComponent permissionName={INVOICES_UPDATE}>
      <CTooltip content="Editar">
        <CButton
          className="text-white"
          color="warning"
          onClick={() => {
            onUpdateClick(currentInvoice);
          }}
        >
          <i className="fa fa-pencil"></i>
        </CButton>
      </CTooltip>
    </PermissionRequiredComponent>
  );

  const deleteButton = (
    <PermissionRequiredComponent permissionName={INVOICES_DESTROY}>
      <CTooltip content="Eliminar">
        <CButton
          className="text-white"
          color="danger"
          onClick={() => {
            onDeleteClick(currentInvoice);
          }}
        >
          <i className="fa fa-trash"></i>
        </CButton>
      </CTooltip>
    </PermissionRequiredComponent>
  );

  const shouldShowEditButton = currentInvoice.creationType === "manual";

  const readButton = (
    <PermissionRequiredComponent permissionName={INVOICES_RETRIEVE}>
      <CTooltip content="Ver Datos">
        <CButton
          className="text-white"
          color="info"
          onClick={() => {
            onReadClick(currentInvoice);
          }}
        >
          <i className="fa fa-eye"></i>
        </CButton>
      </CTooltip>
    </PermissionRequiredComponent>
  );

  return (
    <td className="text-center">
      <CButtonGroup>
        {readButton}
        {shouldShowEditButton ? <>{editButton}</> : <></>}
        {deleteButton}
      </CButtonGroup>
    </td>
  );
};

export default InvoiceCrudActions;
